export default __webpack_public_path__ + "static/location-15f28971f14d88d6cff4990a062d7f5e.svg";